import React, { Fragment, useState } from 'react'
import DeleteBtn from '../../buttons/DeleteBtn'
import NullMssg from '../../common/NullMssg'
import _ from 'lodash'
import EditBtn from '../../buttons/EditBtn'
import { mssgs } from '../../../constantes/mssgs'
import { useDispatch } from 'react-redux'
import { productsActions } from '../../../actions/articlesActions'

const CategoriesList = ({ allCategories, handleRemove, openEditModal }) => {
  // Estado para manejar múltiples niveles de expansión
  const [expandedItems, setExpandedItems] = useState({})
  const [itemsData, setItemsData] = useState({})
  const [loading, setLoading] = useState({})
  const dispatch = useDispatch()
  // Función unificada para manejar la expansión de cualquier item
  const handleItemExpansion = async (item, isCategory = true) => {
    const itemId = isCategory ? item.id_TipoCategoria : item.id_Articulo
    const isExpanded = expandedItems[itemId]

    if (isExpanded) {
      // Si está expandido, contraerlo
      setExpandedItems((prev) => ({
        ...prev,
        [itemId]: false,
      }))
      return
    }

    // Si está contraído, expandirlo y cargar sus hijos
    setLoading((prev) => ({ ...prev, [itemId]: true }))

    try {
      const response = isCategory
        ? await dispatch(productsActions.getArticlesByCategoryId(itemId))
        : await dispatch(productsActions.getArticlesOfAFatherId(itemId))

      const payload = response && response.payload ? response.payload : []

      // Filtrar solo los items que no son artículos finales (para mostrar solo carpetas)
      const filteredItems = payload.filter((item) => !item.isArticuloFinal)

      // Guardar los datos
      setItemsData((prev) => ({
        ...prev,
        [itemId]: filteredItems,
      }))

      // Marcar como expandido
      setExpandedItems((prev) => ({
        ...prev,
        [itemId]: true,
      }))
    } catch (error) {
      console.error('Error cargando items:', error)
    } finally {
      setLoading((prev) => ({ ...prev, [itemId]: false }))
    }
  }

  // Función recursiva para renderizar items en árbol
  const renderTreeItem = (item, level = 0, isCategory = true) => {
    const itemId = isCategory ? item.id_TipoCategoria : item.id_Articulo
    const isExpanded = expandedItems[itemId]
    const isLoading = loading[itemId]
    const childItems = itemsData[itemId] || []
    const hasChildren = childItems.length > 0

    // Estilos para la celda (sin indentación para mantener alineación)
    const cellStyle = {
      cursor: 'pointer',
      padding: '12px',
      minHeight: '52px',
      borderBottom: level > 0 ? '1px solid #f0f0f0' : 'none',
      verticalAlign: 'middle',
    }

    // Estilos para el contenido interno (con indentación)
    const contentStyle = {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: `${level * 25}px`, // Solo indentar el contenido
      width: '100%',
    }

    // Ícono de expansión
    const expandIcon = (
      <span
        style={{
          marginRight: '10px',
          fontSize: '12px',
          width: '12px',
          height: '12px',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#666',
        }}
      >
        {isLoading ? '⏳' : isExpanded ? '▼' : '▶'}
      </span>
    )

    // Estilo diferente para productos finales (últimas subcategorías)
    const itemStyle = {
      fontWeight: level === 0 ? '600' : '400',
      color: level === 0 ? '#2c3e50' : level === 1 ? '#34495e' : '#7f8c8d',
      fontSize: level === 0 ? '14px' : '13px',
      margin: 0,
      lineHeight: '1.4',
    }

    // Estilo para las etiquetas de tipo
    const labelStyle = {
      fontSize: '10px',
      color: '#95a5a6',
      marginLeft: '8px',
      fontWeight: '400',
      opacity: '0.8',
    }

    // Fila principal del item
    const mainRow = (
      <tr
        key={`${level}-${itemId}`}
        style={{
          backgroundColor: level > 0 ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
          transition: 'background-color 0.4s ease',
        }}
      >
        <td
          onClick={() => handleItemExpansion(item, isCategory)}
          style={cellStyle}
          className={level > 0 ? 'subcategory-row' : 'category-row'}
        >
          <div style={contentStyle}>
            {expandIcon}
            <span
              style={{
                opacity: level > 0 ? 0.6: 1,
                fontWeight: level > 0 ? 100 : undefined
              }}
            >{item.nombre}</span>
            {level > 0 && (
                <span style={labelStyle}>
                  ({isCategory ? 'Categoría' : 'Subcategoría'})
                </span>
              )}
          </div>
          {/* <div style={contentStyle}>
            {expandIcon}
            <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              <span style={itemStyle}>{item.nombre}</span>
              {level > 0 && (
                <span style={labelStyle}>
                  ({isCategory ? 'Categoría' : 'Subcategoría'})
                </span>
              )}
            </div>
          </div> */}
        </td>
        <td
          className="table-td-actions"
          style={{
            width: '10%',
            padding: '12px',
            verticalAlign: 'middle',
            textAlign: 'center',
          }}
        >
          {isCategory && level === 0 && (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  openEditModal(item)
                }}
              >
                <EditBtn />
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  handleRemove(itemId)
                }}
              >
                <DeleteBtn />
              </button>
            </>
          )}
        </td>
      </tr>
    )

    // Renderizar hijos si está expandido
    const childRows =
      isExpanded && hasChildren
        ? childItems.flatMap((childItem) =>
            renderTreeItem(childItem, level + 1, false),
          )
        : []

    return [mainRow, ...childRows]
  }

  const allCategoriesSorted = _.orderBy(allCategories, ['nombre'], ['asc'])

  return (
    <>
      <Fragment>
        <div className='table-wrapper '>
          <table className='categories-table'>
            <thead>
              <tr>
                <th>
                  Nombre
                </th>
                <th className="table-th-actions" style={{ width: '120px', minWidth: '120px' }}>
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              {allCategoriesSorted.length > 0 ? (
                allCategoriesSorted.flatMap((category) =>
                  renderTreeItem(category, 0, true),
                )
              ) : (
                <tr>
                  <td colSpan='2'>
                    <NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_CATEGORIAS} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Fragment>
    </>
  )
}

export default CategoriesList
